import { existsAndNotEmpty } from "stentor-utils";

import { GetWebsiteAnalysisQuery } from "generated/graphql";
import { TEMPLATES } from "constants/templates";

import { OnboardingProps } from "../models";
import { determineCMS, CMSType } from "./determineCMS";

/**
 * Turn Website Analysis data into initial props for the Create App
 *
 * @param website
 * @param siteData
 * @param email
 * @returns
 */
export const analyzeWebsiteData = (
    website: string,
    siteData: GetWebsiteAnalysisQuery,
    email?: string
): Partial<OnboardingProps> => {
    const data = siteData?.onboarding?.webDetailsExecution?.data;

    const name = data?.business?.name;
    const primaryColor = data?.site?.primaryColor;
    const secondaryColor = data?.site?.secondaryColor;
    const logo = data?.site?.logo;
    const businessDescription = data?.site?.description;
    const category = data?.business?.category;

    const leadsContact = email;

    const technologies = data?.detectedTechnologies;

    const cms: CMSType = determineCMS(technologies);

    const initialAppProps: Partial<OnboardingProps> = {
        businessDescription,
        logo,
        name,
        primaryColor,
        secondaryColor,
        website,
        leadsContact,
        technologies,
        cms,
    };

    if (existsAndNotEmpty(technologies)) {
        const debugTechnology: string[] = (technologies || [])
            .filter((tech) => {
                return tech.installed;
            })
            .map((tech) => {
                return tech.technology;
            });

        console.log(`Technologies detected: ${debugTechnology.join(",")}`);
    }

    if (existsAndNotEmpty(data?.business?.phoneNumbers)) {
        // try to get phone number
        const firstNumber = data.business.phoneNumbers[0].number;
        if (firstNumber) {
            initialAppProps.leadsContactPhone = firstNumber;
        }
    }

    if (category) {
        const foundMatchingTemplate = TEMPLATES.find((template) => template.id === category);
        if (foundMatchingTemplate) {
            initialAppProps.template = foundMatchingTemplate;
        }
    }

    return initialAppProps;
};
